import FormulaireTicket from "../../components/FormulaireTicket";

export default function Creer({}){

    return(
        <>
            <div style={{height:20}}></div>
            <FormulaireTicket admin={true} callback={()=>{}}/>
        </>
    )
}